import React from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import ProductCards from '../products/ProductCards'
import ControlButtons from './ControlButtons'
import ShoppingCart from '../cart/ShoppingCart'
import CubeSwiper from './CubeSwiper'
import ProgressBar from './ProgressBar'
import get from 'lodash/get'
import isNil from 'lodash/isNil'

const Showcase = (
  { settings,
    cart,
    showcaseNum,
    productShown,
    scene,
    isCartOpened,
    showProduct,
    handleSlideChange,
    previousScene,
    nextScene,
    switchCart,
    closeProduct,
    openSettings,
    closeSettings,
    isVisible,
    editMode,
    showcaseMode,
    setShareButtonsVisible,
    prodMode }) => {

  let redirectUrl = settings.appSettings.redirectUrl
  const addRedirectScene = !editMode && !showcaseMode && !isNil(redirectUrl) && redirectUrl !== '' && get(settings, 'appSettings.autoRedirectEnabled') === true
  redirectUrl = (redirectUrl && redirectUrl.indexOf('://') === -1) ? 'http://' + redirectUrl : redirectUrl
  let slidesCount = settings.showcases.length
  if (settings.lastScene) slidesCount = slidesCount + 1
  return (
    <CSSTransitionGroup
      transitionName='ou_swiper'
      transitionEnterTimeout={1000}
      transitionLeaveTimeout={100}
    >
      {isVisible && [
        <CubeSwiper
          showcases={settings.showcases}
          lastScene={settings.lastScene}
          addRedirectScene={addRedirectScene}
          redirectUrl={redirectUrl}
          showProduct={showProduct}
          onSlideChange={handleSlideChange}
          slide={showcaseNum}
          key='swiper'
          editMode={editMode}
          setShareButtonsVisible={setShareButtonsVisible}
        />,
        <ShoppingCart
          cart={cart}
          onClose={switchCart}
          isVisible={isCartOpened}
          key='cart'
          prodMode={prodMode}
        />,
        <ControlButtons
          onCart={(cart && cart.products.length > 0) ? switchCart : null}
          onLeft={showcaseNum > 0 ? previousScene : null}
          onRight={showcaseNum < settings.showcases.length ? nextScene : null}
          key='buttons'
        />,
        <ProductCards
          showcases={settings.showcases}
          scene={scene}
          productShown={productShown}
          closeProduct={closeProduct}
          openSettings={openSettings}
          closeSettings={closeSettings}
          key='products'
          productsDict={settings.productsDict}
          prodMode={prodMode}
        />,
        <ProgressBar key='progress' progress={(showcaseNum + 1) / (slidesCount)} visible />
      ]}
    </CSSTransitionGroup>
  )
}

Showcase.propTypes = {
  settings: PropTypes.object,
  cart: PropTypes.object,
  showcaseNum: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
  productShown: PropTypes.number,
  scene: PropTypes.string,
  isCartOpened: PropTypes.bool,
  showProduct: PropTypes.func,
  handleSlideChange: PropTypes.func,
  previousScene: PropTypes.func,
  nextScene: PropTypes.func,
  switchCart: PropTypes.func,
  closeProduct: PropTypes.func,
  openSettings: PropTypes.func,
  closeSettings: PropTypes.func,
  isVisible: PropTypes.bool,
  editMode: PropTypes.bool,
  showcaseMode: PropTypes.bool,
  setShareButtonsVisible: PropTypes.func,
  prodMode: PropTypes.bool
}

export default Showcase



// WEBPACK FOOTER //
// ./src/templates/outSide/components/showcase/Showcase.js